const SET_CURRENT_PAGE_TITLE = 'SET_CURRENT_PAGE_TITLE';
const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';

export { SET_CURRENT_PAGE_TITLE, SET_QUERY_PARAMS };
